<template>
	<el-drawer title="修改余额" :visible.sync="visible" @close='close' size="1000px" :close-on-press-escape="false" :wrapperClosable="false"
		id="comDrawer" :modal-append-to-body="false">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerCom">
					<div class="drawerComL">修改为</div>
					<div class="drawerComR">
						<el-input v-model="yue" placeholder="请输入" style="width:150px;"></el-input>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">备注</div>
					<div class="drawerComR">
						<el-input type="textarea" :rows="4" v-model="remark" placeholder="请输入" style="width: 600px;" resize="none"></el-input>
					</div>
				</div>
			</div>
			<div class="drawerViewB">
				<div class="btn2" @click="close">取消</div>
				<div class="btn" @click="submit">确定</div>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	export default {
		data() {
			return {
				visible: true,
				
				yue:0,
				remark:'',
			}
		},
		props:{
			id:{
				default:''
			},
			money:{
				default:0,
			}
		},
		mounted(){
			this.yue = this.money
		},
		methods: {
			close() {
				this.$emit("submit", {type:'close'});
			},
			//提交
			submit(){
				let params = {
					"userId": this.id,
					"yue": Number(this.yue),  // 锁定天数
					"remark": this.remark,
				}
				console.log(params)
				this.$http.get(process.env.VUE_APP_member + '/api/middlewear/MmeberPropertyRecord/update/yue', params).then((res) => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.$emit("submit", {type:'success',data:this.yue});
					}
				})
			},
			
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;
		display: flex;
		flex-direction: column;
		.drawerViewT {
			flex: 1;
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;
			.drawerCom{
				display: flex;
				margin-top: 32px;
				.drawerComL{
					width: 132px;
					margin-right: 22px;
					font-size: 14px;
					color: #343440;
					text-align: right;
					line-height: 20px;
					margin-top: 12px;
				}
				.drawerComR{
					flex: 1;
					.drawerSelect{
						display: flex;
						.drawerSelectItem{
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #69697B;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							div:nth-of-type(1){
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 16px;
								height: 16px;
								border-radius: 100%;
								border: solid 1px #B0B0BF;
							}
						}
						.drawerSelectActiveItem{
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #577BFF;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							border: 1px solid #577BFF;
							div:nth-of-type(1){
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 4px;
								height: 4px;
								border-radius: 100%;
								border: solid 6px #577BFF;
							}
						}
					}
				}
			}
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				cursor: pointer;
				box-sizing: border-box;
				border: solid 1px #577BFF;
				color: #577BFF;
			}
		}
	}
</style>
